import { Component, OnInit } from '@angular/core';
import {MatTableDataSource} from "@angular/material/table"
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/features/pages/authmanagement/services/Auth.service';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { environment } from "src/environments/environment";
@Component({
  selector: "userpage",
  templateUrl: "./userPage.component.html",
  styleUrls: ["./userPage.component.css"],
})
export class UserPageComponent implements OnInit {
  isLoadingPanel: boolean;
  public isAuthenticated: boolean = false;

  
  DataSource: MatTableDataSource<unknown>;
  Columns: string[] = ["UUID", "UserName", "Nombre", "Apellido Paterno","Apellido Materno","Rol"];
  Actions: string[] = ["Enlazar"];
  Data: any;
  pageSizeOptions = [10, 20, 20];
  resultsLength = 0;
  isLoadingResults = true;
  hasActions = true;
  isFilterVisible;
  roles: string;
  isAdmin: boolean = false;
  isSuperuser: boolean = false;
  

  subscription_GetLoading: Subscription;
  subscription_CheckAuthentication: Subscription;
  public isAllowed: boolean;

  constructor(
    private authService: AuthService,
    private sessionService: SessionService
  ) {
    this.isFilterVisible = false;   
    this.isAllowed = false;
  }

  ngOnInit(): void {
    // this.CheckAuthentication();
    this.sessionService.setIsExternalMap(false);
  }



  ngOnDestroy() {
    if (this.subscription_GetLoading)
    this.subscription_GetLoading.unsubscribe();
    if(this.subscription_CheckAuthentication) this.subscription_CheckAuthentication.unsubscribe();

  }
  

  CheckAuthentication() {
    this.subscription_CheckAuthentication = this.authService
      .checkAuthenticated()
      .subscribe({
        next: (arg) => {
          this.isAuthenticated = arg;
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al verificar ttoken', error);
        }
      });
    if(!environment.production) console.log("Authenticated:" + this.isAuthenticated);
  }

   showFiltersCallback(event) {
    if(!environment.production) console.log("Received");
    // this.filterDialogRef = this.dialog.open(UsersFiltersComponent, {
    //   width: "350px",
    //   position: { right: "0" },
    //   height: "100vh",
    //   data: { download: false },
    // });
  }


filterCallback(filtro){
  if(!environment.production) console.log(this.DataSource);
  // this.DataSource.filter = filtro.trim().toLowerCase();
}

}